import React from 'react';
import { PhoneCall } from 'lucide-react';
import ReservationDialog from './ReservationDialog';
import { BRAND } from '../mock';

const CTA = () => {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl p-8 sm:p-10 lg:p-14 border border-[color:var(--brand-50)]" style={{ background: 'linear-gradient(135deg, #E9FAFB 0%, #F7FEFE 100%)' }}>
          <div className="bubble hidden sm:block" style={{ width: 260, height: 260, top: -80, right: -60 }} />
          <div className="bubble hidden sm:block" style={{ width: 160, height: 160, bottom: -50, left: -30, opacity: 0.5 }} />

          <div className="relative grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <span className="inline-block px-3 py-1 rounded-full bg-white text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3 border border-[color:var(--brand-50)]">Pesan Sekarang</span>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)] leading-tight">
                Cucian di rumah <span className="text-[color:var(--brand)]">sudah numpuk?</span>
              </h2>
              <p className="text-[color:var(--muted)] mt-4 max-w-lg">
                Jangan ragu untuk menghubungi kami. Komunikasikan kebutuhan laundry Anda, kami siap jemput dalam 30 menit.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <a href={BRAND.whatsapp} target="_blank" rel="noreferrer" className="btn-brand flex items-center gap-2"><PhoneCall className="w-4 h-4" /> Hubungi Kami</a>
                <ReservationDialog trigger={<button className="btn-brand-outline">Reservasi Sekarang</button>} />
              </div>
            </div>

            <div className="lg:justify-self-end w-full max-w-md">
              <div className="bg-white rounded-2xl border border-[color:var(--brand-50)] shadow-xl p-6">
                <div className="text-sm text-[color:var(--muted)]">Customer Service</div>
                <a href={`tel:${BRAND.phoneLink}`} className="font-display text-2xl font-extrabold text-[color:var(--ink)] hover:text-[color:var(--brand)] transition-colors block">{BRAND.phone}</a>
                <div className="mt-4 grid grid-cols-2 gap-3 text-center">
                  <div className="rounded-xl bg-[color:var(--brand-50)] p-4">
                    <div className="font-extrabold text-[color:var(--brand)] text-2xl">30</div>
                    <div className="text-[11px] text-[color:var(--muted)] uppercase tracking-wider">Menit Pickup</div>
                  </div>
                  <div className="rounded-xl bg-[color:var(--brand-50)] p-4">
                    <div className="font-extrabold text-[color:var(--brand)] text-2xl">4</div>
                    <div className="text-[11px] text-[color:var(--muted)] uppercase tracking-wider">Jam Quick</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
